/**
 * RENDERING: MazeRenderer
 * Rendering del labirinto, dots e power pellets
 */

import { GAME_CONFIG, COLORS } from '../types/GameConstants'

export class MazeRenderer {
  static render(
    ctx: CanvasRenderingContext2D,
    maze: number[][],
    dots: Set<string>,
    powerPellets: Set<string>
  ) {
    // Draw maze
    maze.forEach((row, rowIndex) => {
      row.forEach((cell, colIndex) => {
        const x = colIndex * GAME_CONFIG.CELL_SIZE
        const y = rowIndex * GAME_CONFIG.CELL_SIZE
        
        if (cell === 1) {
          // Wall
          ctx.fillStyle = COLORS.WALL
          ctx.fillRect(x, y, GAME_CONFIG.CELL_SIZE, GAME_CONFIG.CELL_SIZE)
          
          // Wall highlight
          ctx.fillStyle = COLORS.WALL_HIGHLIGHT
          ctx.fillRect(x, y, GAME_CONFIG.CELL_SIZE, 2)
          ctx.fillRect(x, y, 2, GAME_CONFIG.CELL_SIZE)
        } else if (cell === 2) {
          // Ghost house
          ctx.strokeStyle = COLORS.GHOST_HOUSE
          ctx.setLineDash([5, 5])
          ctx.strokeRect(x + 2, y + 2, GAME_CONFIG.CELL_SIZE - 4, GAME_CONFIG.CELL_SIZE - 4)
          ctx.setLineDash([])
        }
      })
    })

    // Draw dots
    ctx.fillStyle = COLORS.DOT
    dots.forEach(dotKey => {
      const [col, row] = dotKey.split(',').map(Number)
      ctx.beginPath()
      ctx.arc(
        col * GAME_CONFIG.CELL_SIZE + GAME_CONFIG.CELL_SIZE/2, 
        row * GAME_CONFIG.CELL_SIZE + GAME_CONFIG.CELL_SIZE/2, 
        2, 
        0, 
        Math.PI * 2
      )
      ctx.fill()
    })

    // Draw power pellets (animated)
    const pulse = Math.sin(Date.now() * 0.005) * 0.5 + 0.5
    ctx.fillStyle = COLORS.POWER_PELLET
    powerPellets.forEach(pelletKey => {
      const [col, row] = pelletKey.split(',').map(Number)
      ctx.beginPath()
      ctx.arc(
        col * GAME_CONFIG.CELL_SIZE + GAME_CONFIG.CELL_SIZE/2, 
        row * GAME_CONFIG.CELL_SIZE + GAME_CONFIG.CELL_SIZE/2, 
        5 + pulse * 3, 
        0, 
        Math.PI * 2
      )
      ctx.fill()
    })
  }
}
